var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEsao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500pt",
    height: "190pt",
    viewBox: "0 0 740 280",
    style: {
      enableBackground: "new 0 0 741.89 339.65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n\t.st1{fill:#9ca7ba;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M653.04,117.67c-15.25-12.24-35.03-18.46-58.95-18.46h-0.55h-4.99H588c-23.54,0-43.13,6.59-58.76,19.77 c-15.44,12.99-23.16,29.57-23.16,49.34c0,19.77,7.72,35.97,22.98,48.21C544.31,228.78,564.08,235,588,235h0.55h4.99h0.55 c23.54,0,43.13-6.59,58.76-19.77c15.44-12.99,23.16-29.57,23.16-49.34C676.02,146.11,668.3,129.91,653.04,117.67z M622.91,190.93 c-7.53,5.84-17.14,8.85-28.81,8.85h-0.55v0H588c-11.49,0-21.09-3.2-28.81-9.42c-7.53-6.22-11.3-14.12-11.3-23.73 s3.77-17.52,11.3-23.54c7.53-5.84,17.14-8.85,28.81-8.85h0.55v0h5.55c11.49,0,21.09,3.2,28.81,9.42 c7.53,6.22,11.3,14.12,11.3,23.73C634.21,176.99,630.44,184.9,622.91,190.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.82,149.3h-54.36c-3.97-0.17-7.15-3.44-7.15-7.46c0-4.13,3.35-7.47,7.47-7.47h42.19h51.9l22.1-35.38 H256.39V99c-23.48,0.21-42.46,19.31-42.46,42.84c0,23.67,19.18,42.85,42.85,42.85l54.03-0.02c4.13,0,7.47,3.35,7.47,7.47 c0,4.13-3.35,7.47-7.47,7.47h-0.15H104.25v-14.93h81.74V149.3l-81.74,0.02v-15.09h97.97V98.89H66V235h244.66v0 c0.05,0,0.1,0,0.15,0c23.67,0,42.85-19.18,42.85-42.85C353.67,168.48,334.48,149.3,310.82,149.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "434.57,148.98 389.33,224.3 389.33,236 434.57,200.3 479.7,236 479.7,224.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373.99,196.25 436.01,102.94 498.02,196.25 536.03,196.25 436,36.18 335.98,196.25  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEsao);
export default __webpack_public_path__ + "static/media/logo_esao.450cdba30003f0e23dfc5e103442606b.svg";
export { ForwardRef as ReactComponent };